/**
 * The type of (redux) action which sets the hints settings.
 */
export const SET_HINTS = 'SET_HINTS';
